import { createContext } from 'react';

import { IEspClient } from '../IEspClient';

export const EspClientContext: React.Context<IEspClient | null> = createContext<IEspClient | null>(null);
